import { Module } from '@nestjs/common';
import { ConfigModule } from '@nestjs/config';
import configuration from '../config/configuration';
import { DatabaseModule } from '../database';
import { AIGeneratedQpModule } from './ai-generated-qp/ai-generated-qp.module';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import { QuestionBankCreationModule } from './create-questions/create-question-module';
import { ModelPaperModule } from './model-paper/model-paper.module';
import { AuthenticationsModule } from './authentications/authentications.module';

@Module({
  imports: [
    ConfigModule.forRoot({
      isGlobal: true,
      envFilePath: './.env',
      load: [configuration],
    }),
    DatabaseModule,
    AIGeneratedQpModule,
    ModelPaperModule,
    QuestionBankCreationModule,
    AuthenticationsModule,
  ],
  controllers: [AppController],
  providers: [AppService],
})
export class AppModule { }
